import React, { useState, useEffect } from "react";
import { Box, Checkbox, Typography } from "@mui/material";

import Home from "./Home";
import Login from "./Login";
import Register from "./Register";

const Loginpage = ({ mobile, setStep, setLoading, setLoggedIn, setUser }) => {
  const [state, setState] = useState(0); // 0 = welcome, 1 = login, 2+ = register

  useEffect(() => {
    localStorage.setItem("fullpass_location_permission_prompt", false);
  }, []);

  return (
    <>
      {(state == 0 || !mobile) && (
        <img
          src="img/login-background3.png"
          alt="background"
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
            position: "absolute",
            left: 0,
            top: 0,
            opacity: 1,
          }}
        />
      )}
      <Box
        style={{
          width: "100vw",
          height: "100%",
          position: "absolute",
          left: 0,
          top: 0,
          display: "flex",
          flexDirection: mobile ? "column" : "row",
          justifyContent: "space-between",
        }}
      >
        {(state == 0 || !mobile) && (
          <div style={{ width: "500px", maxWidth: mobile ? "80vw" : "95vw", paddingTop: "5vh" }}>
            <img src="img/login-lateral-slide.png" style={{ width: "100%", height: "auto", objectFit: "contain" }} />
          </div>
        )}

        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: mobile && state > 0 ? "flex-start" : "center",
            alignItems: "center",
            height: "100%",
            paddingRight: !mobile ? "10%" : "0",
            paddingLeft: !mobile ? "5%" : "5%",
            marginLeft: !mobile ? "10px" : "0",
            maxWidth: !mobile ? "400px" : "90%",
            gap: state == 0 ? "10px" : "20px",
            backgroundColor: state == 0 ? "rgba(0,0,0,0)" : "#181A20",
          }}
        >
          {state == 0 && <Home setState={setState} mobile={mobile} />}
          {state == 1 && (
            <Login setState={setState} mobile={mobile} setLoggedIn={setLoggedIn} setLoggedInUser={setUser} />
          )}
          {state >= 2 && <Register setState={setState} mobile={mobile} state={state} />}
        </Box>
      </Box>
    </>
  );
};

export default Loginpage;
